import { useEffect } from "react";

import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { setShowSearch } from "../../store/appConfigsSlice";

import { useAuth } from "../../context/auth";

import { ActivateByTokenForm } from "../../components/auth";

const ActivateUserPage = () => {
  const dispatch = useDispatch();
  const { isAuth } = useAuth();
  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, [dispatch]);

  if (isAuth) {
    navigate("/");
    return null;
  }

  return <ActivateByTokenForm token={token} />;
};

export default withTranslation()(ActivateUserPage);
